import { render } from "./BarcodesList.vue?vue&type=template&id=53efaad2"
import script from "./BarcodesList.vue?vue&type=script&lang=js"
export * from "./BarcodesList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__